import styled from 'styled-components';
import { tokens } from '@welbe/web-design-system';

export const CodeContainer = styled.div<{ error?: boolean }>`
	display: grid;
	grid-template-columns: repeat(6, 1fr);
	max-width: 322px;
	gap: 10px;
	width: 100%;

	input {
		width: 45px;
		height: 45px;
		font-family: Montserrat, sans-serif;
		line-height: 180%;
		display: block;
		padding: 8px 14px;
		border: none;
		border-radius: 0.2rem;
		background: #f5f7fa;
		-webkit-transition: 0.2s;
		transition: 0.2s;
		border: 2px solid ${({ error }) => (error ? 'tomato' : '#f5f7fa')};
		box-sizing: border-box;
		font-size: 16px;
		color: #64778f;
		font-weight: 600;
		-webkit-animation: shake 300ms;
		animation: shake 300ms;

		&:focus {
			outline: none;
			border: 2px solid
				${({ error }) => (error ? 'tomato' : tokens.color_primary)};
		}
	}
`;

export const CodeLabel = styled.p`
	font-family: Montserrat, sans-serif;
	font-size: 14px;
	margin: 0 0 10px 4px;
`;

export const ResendCode = styled.div`
	font-size: 12px;
	margin: 4px 0;
	color: #64778f;
	display: flex;
	justify-content: right;
	cursor: pointer;

	&:hover {
		color: #64778fcc;
	}
`;
